
export const getEnvVar = (key: string, fallback: string = ""): string => {
    let fromEnvJson: unknown = undefined;

    try {
        if (typeof window !== "undefined" && window._env_) {
            fromEnvJson = window._env_[key];
        }
    } catch (e) {
        console.warn(`⚠️ Errore accedendo a window._env_[${key}]:`, e);
    }

    const fromVite = import.meta.env?.[key];
    const value = fromEnvJson ?? fromVite ?? fallback;

    return String(value);
};



export const getBaseEnv = (): string => {
    return getEnvVar('VITE_BASE_URL');
};


export const getApiEndpoints = (): {LOGIN: string, RESET_PSW: string, FORGET_PSW: string, AUTHORIZE: string, AUTHORIZE_2FA: string} => {
    return {
        LOGIN: `${getBaseEnv()}/nova/bper/nexiauth/openid/login`,
        RESET_PSW: `${getBaseEnv()}/nova/bper/nexiauth/reset-password`,
        FORGET_PSW: `${getBaseEnv()}/nova/bper/nexiauth/forgot-password`,
        AUTHORIZE: `${getBaseEnv()}/nova/bper/nexiauth/openid/authorize`,
        AUTHORIZE_2FA: `${getBaseEnv()}/nova/bper/nexiauth/2fa`,
    };
};

